module.exports = __webpack_public_path__ + "img/icon-apply.b93efb4e.svg";